// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.greeting-screen {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #6dd5ed 0%, #2193b0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.6s ease;
}
.greeting-screen.visible {
  opacity: 1;
  pointer-events: all;
}
.greeting-screen.hidden {
  opacity: 0;
  pointer-events: none;
}
.greeting-content {
  text-align: center;
  color: #fff;
}
.greeting-svg-animation {
  margin: 0 auto 32px auto;
  width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle {
  fill: #fff;
  opacity: 0.8;
  transform-origin: 50% 50%;
  animation: bounce 1.2s infinite;
}
.c1 {
  fill: #ffb347;
  animation-delay: 0s;
}
.c2 {
  fill: #6dd5ed;
  animation-delay: 0.2s;
}
.c3 {
  fill: #ff5e62;
  animation-delay: 0.4s;
}
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  20% { transform: translateY(-18px); }
  40% { transform: translateY(0); }
  60% { transform: translateY(-10px); }
  80% { transform: translateY(0); }
}
h1 {
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 1px;
} `, "",{"version":3,"sources":["webpack://./src/components/greeting/GreetingScreen.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;EACpC,MAAM,wBAAwB,EAAE;EAChC,MAAM,4BAA4B,EAAE;EACpC,MAAM,wBAAwB,EAAE;AAClC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".greeting-screen {\r\n  position: fixed;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: linear-gradient(135deg, #6dd5ed 0%, #2193b0 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.6s ease;\r\n}\r\n.greeting-screen.visible {\r\n  opacity: 1;\r\n  pointer-events: all;\r\n}\r\n.greeting-screen.hidden {\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n.greeting-content {\r\n  text-align: center;\r\n  color: #fff;\r\n}\r\n.greeting-svg-animation {\r\n  margin: 0 auto 32px auto;\r\n  width: 120px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.circle {\r\n  fill: #fff;\r\n  opacity: 0.8;\r\n  transform-origin: 50% 50%;\r\n  animation: bounce 1.2s infinite;\r\n}\r\n.c1 {\r\n  fill: #ffb347;\r\n  animation-delay: 0s;\r\n}\r\n.c2 {\r\n  fill: #6dd5ed;\r\n  animation-delay: 0.2s;\r\n}\r\n.c3 {\r\n  fill: #ff5e62;\r\n  animation-delay: 0.4s;\r\n}\r\n@keyframes bounce {\r\n  0%, 100% { transform: translateY(0); }\r\n  20% { transform: translateY(-18px); }\r\n  40% { transform: translateY(0); }\r\n  60% { transform: translateY(-10px); }\r\n  80% { transform: translateY(0); }\r\n}\r\nh1 {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  letter-spacing: 1px;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
